import { Icons } from "atoms/constants/icons";
import { SearchFormSizes } from "molecules/enums/search-form-sizes";
import { SearchFormStyles } from "molecules/enums/search-form-style";
import SearchForm from "molecules/forms/search-form";
import React, { useEffect, useState } from "react";
import { t } from "utilities/localization-utils";

interface SearchBookmarksProps {
    searchText: string;
    onChange: (newSearchText: string) => void;
    placeHolder?: string;
}

const SearchBookmarks = ({
    searchText,
    onChange,
    placeHolder,
}: SearchBookmarksProps) => {
    const [searchTextInput, setSearchTextInput] = useState(searchText);

    const handleClearSearchTextForm = () => {
        setSearchTextInput("");
        onChange("");
    };

    const handleSearchTextChanged = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        setSearchTextInput(e.target.value);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        onChange(searchTextInput);
    };

    // Clears out search text in field if it has been removed from external means (i.e., param removed as part of refresh)
    useEffect(() => {
        if (!searchText && searchTextInput) {
            setSearchTextInput("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchText]);

    return (
        <SearchForm
            accessibleText={t(
                "myBookmarksTabFilters-searchForm-accessibleText"
            )}
            buttonIcon={Icons.Search}
            id="my-bookmarks-search-input"
            onClear={handleClearSearchTextForm}
            onSearchClick={handleSearch}
            onSearchTextChange={handleSearchTextChanged}
            onSubmit={handleSearch}
            placeholder={
                placeHolder ?? t("myBookmarksTabFilters-searchForm-placeholder")
            }
            searchText={searchTextInput}
            size={SearchFormSizes.Large}
            style={SearchFormStyles.TertiaryAlt}
        />
    );
};

export default SearchBookmarks;
